<template>
  <!-- 联系我们 -->
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 联系我们轮播图 -->
    <ContactBanner></ContactBanner>
    <!-- 联系我们 -->
    <ContactUs></ContactUs>
    <!-- 联系我们地图 -->
    <ContactMap></ContactMap>
    <!-- 在线留言 -->
    <Message></Message>
    <!-- 底部导航 -->
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/mobile/components/TopNav.vue";
import BottomNav from "../../../components/mobile/components/BottomNav.vue";
import ContactBanner from "../../../components/mobile/Contact/ContactBanner.vue";
import ContactUs from "../../../components/mobile/Contact/ContactUs.vue";
import ContactMap from "../../../components/mobile/Contact/ContactMap.vue";
import Message from "../../../components/mobile/Contact/Message.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    BottomNav,
    ContactBanner,
    ContactUs,
    ContactMap,
    Message,
  },
};
</script>

<style scoped>
</style>
